import React, { Component } from 'react';
import { connect } from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';
import {ToastsContainer, ToastsStore,ToastsContainerPosition} from 'react-toasts';
import $ from 'jquery';  
import Loader from 'react-loader-spinner';
const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;
var fs = require('browserify-fs');
class Applynow extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          
            fields: {},
			errors: {},
			languagedata:[],
			defaultlang:6,
			Takeapledges:[],
			AllProgrammesCount:0,
			AllCityCount:0,
			AllStateCount:0,
			loaded: false
			
			
        };
		
		

	    this.handleChange = this.handleChange.bind(this);
		this.submitdonateform = this.submitdonateform.bind(this);

    }
    componentDidMount() {
    	$('html, body').animate({
		scrollTop:0
		}, 1000);
	  	
	}

	 componentWillMount() {
    	
	  	const DefaultLang = localStorage.getItem('DefaultLanguage');
	    this.setState({defaultlang: DefaultLang});
		
		//this.gettakeapledgedata(DefaultLang);
	this.getlanguage(DefaultLang);
    
  }


getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}
	handleChange(e) {
      let fields = this.state.fields;
      fields[e.target.name] = e.target.value;
      this.setState({
        fields
      });

    }
    submitdonateform(e) {
	
      e.preventDefault();
      if (this.validateForm()) {
          
         
		 axios.post(`${API_URL}/applynow`, {
		 LanguageID:6,		
		 name: this.state.fields.name,
		 email:this.state.fields.email,
		 phone:this.state.fields.phone,
		 city:this.state.fields.city,
		 province:this.state.fields.province,
		 message:this.state.fields.message,
		 })
		  .then(res => {

        this.setState({ errorMessage: res.data.Message,status_code:res.data.Status});
		ToastsStore.success(res.data.Message);
        if(res.data.Status != 0){
       
        this.setState({fields : { name:'', email:'', phone:'', city:'', province:'', message:''} });
      }
	 
		  })
		  
      }else{
      	$('html, body').animate({
		scrollTop:$("#Address_title_scroll").offset().top-100
		}, 1000);
      }

 }
 validateForm() {

      let fields = this.state.fields;
      let errors = {};
      let formIsValid = true;

      if (!fields["name"]) {
        formIsValid = false;
        errors["name"] = "Please enter full name.";
      }

      if (typeof fields["name"] !== "undefined") {
        if (!fields["name"].match(/^[a-zA-Z ]*$/)) {
          formIsValid = false;
          errors["name"] = "Please enter alphabet characters only.";
        }
      }
	  
	  
	  if (!fields["email"]) {
        formIsValid = false;
        errors["email"] = "Please enter email-ID.";
      }

      if (typeof fields["email"] !== "undefined") {
        //regular expression for email validation
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(fields["email"])) {
          formIsValid = false;
          errors["email"] = "Please enter valid email-ID.";
        }
      }
	  
	  
	   
      if (!fields["phone"]) {
        formIsValid = false;
        errors["phone"] = "Please enter phone no.";
      }

      if (typeof fields["phone"] !== "undefined") {
        if (!fields["phone"].match(/^[0-9]{10}$/)) {
          formIsValid = false;
          errors["phone"] = "Please enter valid phone no.";
        }
      }
      if (!fields["city"]) {
        formIsValid = false;
        errors["city"] = "Please enter City.";
      }
      if (!fields["province"]) {
        formIsValid = false;
        errors["province"] = "Please enter State / Province / Region.";
      }
      if (!fields["message"]) {
        formIsValid = false;
        errors["message"] = "Please enter Message.";
      }
      



      this.setState({
        errors: errors
      });
      return formIsValid;


    }

	
	
  render() {

    return (
      <div className="App">
      <Layout languagedata={this.state.languagedata}>

       {this.state.loaded == true ? (	  
		 
	<div className="divloader"> 
		 <Loader 
			 type="ThreeDots"
			 color="#00BFFF"
			 height="100"	
			 width="100"
		  />		  
	 </div>
	
	) : '' }


      <ToastsContainer position={ToastsContainerPosition.TOP_LEFT} store={ToastsStore} classNames="toast_msg" />
      <section className="banner inner_banner">
		  <div className="bd-example">
		    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
		      <div className="carousel-inner">
		        <div className="carousel-item active">
		          <img src={ IMAGE_URL+'/images/about-banner.jpg' } className="d-block w-100" alt="..." />
		          <div className="carousel-caption d-none d-md-block">
		            <aside>{this.state.languagedata.apply_now}</aside>
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		</section>




		<section className="contact_us Donate_form new-pledges-form">
			<div className="container">
				<div className="row">
		        <form className="form-horizontal has-validation-callback" onSubmit= {this.submitdonateform}>
		          <div className="row">
		          	<div className="col-12">
				      <aside className="Address_title" id="Address_title_scroll">{this.state.languagedata.apply_now}</aside>
				    </div>
		            <div className="col-xl-6 col-lg-6 col-md-6">
		              <div className="form-group">
		                <label for="name">
		                  {this.state.languagedata.Name}</label><span className="errorMsg">*</span>
		                <input type="text"
		                 name="name"
		                  className={this.state.errors.name ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.name ? this.state.errors.name : "Name"}
		                     onChange={this.handleChange}
		                      value={this.state.fields.name}
		                       />
		               
		              </div>
		            </div>
		            <div className="col-xl-6 col-lg-6 col-md-6">  
		              <div className="form-group">
		                <label for="email">
		                  {this.state.languagedata.Email_Address}</label><span className="errorMsg">*</span>
		                
		                  <input type="email"
		                   name="email"
		                    className={this.state.errors.email ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.email ? this.state.errors.email : "Email"}
		                        onChange={this.handleChange}
		                          value={this.state.fields.email} 
		                          />
		              
		                
		              </div>
		            </div>
		            				  
				  <div className="col-xl-4 col-lg-4 col-md-4">
				    <div className="form-group">
				      <label for="name">
				        {this.state.languagedata.Phone}</label><span className="errorMsg">*</span>
				      <input type="text"
				       name="phone"
				        className={this.state.errors.phone ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.phone ? this.state.errors.phone : "Phone"}
				          onChange={this.handleChange}
				           value={this.state.fields.phone} 
				           />
				     
				    </div>
				  </div>
				  
				  <div className="col-xl-4 col-lg-4 col-md-4">
				    <div className="form-group">
				      <label for="name">
				      {this.state.languagedata.State_Province_Region}</label><span className="errorMsg">*</span>
				      <select name="province"
				       className={this.state.errors.province ? "form-control error_class" : "form-control"}
				        onChange={this.handleChange}
				         value={this.state.fields.province} >
							<option value="">Select State</option>
							<option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
							<option value="Andhra Pradesh">Andhra Pradesh</option>
							<option value="Arunachal Pradesh">Arunachal Pradesh</option>
							<option value="Assam">Assam</option>
							<option value="Bihar">Bihar</option>
							<option value="Chandigarh">Chandigarh</option>
							<option value="Chhattisgarh">Chhattisgarh</option>
							<option value="Dadra and Nagar Haveli">Dadra and Nagar Haveli</option>
							<option value="Daman and Diu">Daman and Diu</option>
							<option value="Delhi">Delhi</option>
							<option value="Goa">Goa</option>
							<option value="Gujarat">Gujarat</option>
							<option value="Haryana">Haryana</option>
							<option value="Himachal Pradesh">Himachal Pradesh</option>
							<option value="Jammu and Kashmir">Jammu and Kashmir</option>
							<option value="Jharkhand">Jharkhand</option>
							<option value="Karnataka">Karnataka</option>
							<option value="Kerala">Kerala</option>
							<option value="Lakshadweep">Lakshadweep</option>
							<option value="Madhya Pradesh">Madhya Pradesh</option>
							<option value="Maharashtra">Maharashtra</option>
							<option value="Manipur">Manipur</option>
							<option value="Meghalaya">Meghalaya</option>
							<option value="Mizoram">Mizoram</option>
							<option value="Nagaland">Nagaland</option>
							<option value="Orissa">Orissa</option>
							<option value="Pondicherry">Pondicherry</option>
							<option value="Punjab">Punjab</option>
							<option value="Rajasthan">Rajasthan</option>
							<option value="Sikkim">Sikkim</option>
							<option value="Tamil Nadu">Tamil Nadu</option>
							<option value="Tripura">Tripura</option>
							<option value="Uttaranchal">Uttaranchal</option>
							<option value="Uttar Pradesh">Uttar Pradesh</option>
							<option value="West Bengal">West Bengal</option>
							</select>
				      
				 
				    </div>
				  </div>
				  <div className="col-xl-4 col-lg-4 col-md-4">
				    <div className="form-group">
				      <label for="name">
				        {this.state.languagedata.City}</label><span className="errorMsg">*</span>
				      <input type="text"
				       name="city"
				         className={this.state.errors.city ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.city ? this.state.errors.city : "City"}
				          onChange={this.handleChange}
				            value={this.state.fields.city} 
				            />
				  
				    </div>
				  </div>
				  
		           
		            <div className="col-12">
		              <div className="form-group">
		                <label for="name">
		                 {this.state.languagedata.Message} </label>
		                <textarea 


		                 className={this.state.errors.message ? "form-control error_class Take-a-Pledge-message" : "form-control Take-a-Pledge-message"}
				         placeholder={this.state.errors.message ? this.state.errors.message : "Message"}


		                 name="message"
		                 
		                   onChange={this.handleChange}
		                    value={this.state.fields.message}
		                     rows="4"></textarea>
		                
		              </div>
		            </div>
		            <div className="col-md-12">
		              <button type="submit" className="btn btn-primary pull-right" id="btnContactUs">
		                Submit</button>
		               
		            </div>
		          </div>
		        </form>
		     </div>
		          </div> 
		</section>

		
		<Callusnow languagedata={this.state.languagedata} />
		</Layout>
	  </div>
    );
  }
}

export default Applynow;



// WEBPACK FOOTER //
// ./src/component/Applynow.js